// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLogoPage-Copyright_cls1__u3Kqs","cls2":"VeloLogoPage-Copyright_cls2__smv-a VeloLogoPage-Copyright_cls1__u3Kqs"};